import { html } from 'lit';

export const WarningIcon = html`<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.99935 3.16663C5.32997 3.16663 3.16602 5.33058 3.16602 7.99996C3.16602 10.6693 5.32997 12.8333 7.99935 12.8333C10.6687 12.8333 12.8327 10.6693 12.8327 7.99996C12.8327 5.33058 10.6687 3.16663 7.99935 3.16663ZM2.16602 7.99996C2.16602 4.7783 4.77769 2.16663 7.99935 2.16663C11.221 2.16663 13.8327 4.7783 13.8327 7.99996C13.8327 11.2216 11.221 13.8333 7.99935 13.8333C4.77769 13.8333 2.16602 11.2216 2.16602 7.99996ZM7.99935 5.12959C8.27549 5.12959 8.49935 5.35345 8.49935 5.62959V7.99996C8.49935 8.2761 8.27549 8.49996 7.99935 8.49996C7.72321 8.49996 7.49935 8.2761 7.49935 7.99996V5.62959C7.49935 5.35345 7.72321 5.12959 7.99935 5.12959ZM7.49935 10.3703C7.49935 10.0942 7.72321 9.87033 7.99935 9.87033H8.00528C8.28142 9.87033 8.50528 10.0942 8.50528 10.3703C8.50528 10.6465 8.28142 10.8703 8.00528 10.8703H7.99935C7.72321 10.8703 7.49935 10.6465 7.49935 10.3703Z"
    fill="#77757D"
    fill-opacity="0.6"
  />
</svg>`;

export const InsertBelowIcon = html`<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_7789_6846)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.54102 5.41663C3.54102 5.07145 3.82084 4.79163 4.16602 4.79163H15.8327C16.1779 4.79163 16.4577 5.07145 16.4577 5.41663C16.4577 5.7618 16.1779 6.04163 15.8327 6.04163H4.16602C3.82084 6.04163 3.54102 5.7618 3.54102 5.41663ZM3.54102 8.33329C3.54102 7.98811 3.82084 7.70829 4.16602 7.70829H15.8327C16.1779 7.70829 16.4577 7.98811 16.4577 8.33329C16.4577 8.67847 16.1779 8.95829 15.8327 8.95829H4.16602C3.82084 8.95829 3.54102 8.67847 3.54102 8.33329ZM10.8327 10.625C10.4875 10.625 10.2077 10.9048 10.2077 11.25C10.2077 11.5951 10.4875 11.875 10.8327 11.875H15.8327C16.1779 11.875 16.4577 11.5951 16.4577 11.25C16.4577 10.9048 16.1779 10.625 15.8327 10.625H10.8327ZM10.2077 14.1666C10.2077 13.8214 10.4875 13.5416 10.8327 13.5416H15.8327C16.1779 13.5416 16.4577 13.8214 16.4577 14.1666C16.4577 14.5118 16.1779 14.7916 15.8327 14.7916H10.8327C10.4875 14.7916 10.2077 14.5118 10.2077 14.1666ZM5.20768 10.8333C5.20768 10.4881 4.92786 10.2083 4.58268 10.2083C4.2375 10.2083 3.95768 10.4881 3.95768 10.8333V13.3333C3.95768 13.6785 4.2375 13.9583 4.58268 13.9583H6.87435V14.5833C6.87435 14.8361 7.02663 15.064 7.26017 15.1607C7.49372 15.2575 7.76254 15.204 7.94129 15.0252L9.19129 13.7752C9.43537 13.5312 9.43537 13.1354 9.19129 12.8914L7.94129 11.6414C7.76254 11.4626 7.49372 11.4091 7.26017 11.5059C7.02663 11.6026 6.87435 11.8305 6.87435 12.0833V12.7083H5.20768V10.8333Z"
      fill="#77757D"
      fill-opacity="0.6"
    />
  </g>
  <defs>
    <clipPath id="clip0_7789_6846">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg> `;

export const ResetIcon = html`<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_7823_6905)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.70898 10C2.70898 5.97296 5.97357 2.70837 10.0007 2.70837C11.8678 2.70837 13.5723 3.41097 14.8619 4.56521L14.8639 4.56699L16.0423 5.63083V3.33337C16.0423 2.9882 16.3221 2.70837 16.6673 2.70837C17.0125 2.70837 17.2923 2.9882 17.2923 3.33337V7.03708C17.2923 7.38226 17.0125 7.66208 16.6673 7.66208H12.9636C12.6184 7.66208 12.3386 7.38226 12.3386 7.03708C12.3386 6.6919 12.6184 6.41208 12.9636 6.41208H15.0423L14.0283 5.49662C14.0279 5.49633 14.0276 5.49603 14.0273 5.49573C12.9581 4.53921 11.5479 3.95837 10.0007 3.95837C6.66393 3.95837 3.95898 6.66332 3.95898 10C3.95898 13.3368 6.66393 16.0417 10.0007 16.0417C12.8751 16.0417 15.2821 14.0337 15.8926 11.3432C15.969 11.0066 16.3038 10.7956 16.6404 10.872C16.977 10.9484 17.188 11.2832 17.1116 11.6198C16.3748 14.8671 13.4716 17.2917 10.0007 17.2917C5.97357 17.2917 2.70898 14.0271 2.70898 10Z"
      fill="#77757D"
      fill-opacity="0.6"
    />
  </g>
  <defs>
    <clipPath id="clip0_7823_6905">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const ReplaceIcon = html`<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_7823_6859)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.8132 11.2542C14.6939 11.3852 14.5246 11.4594 14.3474 11.4583C14.1702 11.4572 14.0018 11.381 13.8841 11.2485L12.0322 9.16519C11.8029 8.9072 11.8261 8.51215 12.0841 8.28283C12.3421 8.0535 12.7372 8.07674 12.9665 8.33473L13.7262 9.18942V4.99996C13.7262 4.8849 13.6329 4.79163 13.5179 4.79163H8.33269C7.98751 4.79163 7.70769 4.5118 7.70769 4.16663C7.70769 3.82145 7.98751 3.54163 8.33269 3.54163H13.5179C14.3233 3.54163 14.9762 4.19454 14.9762 4.99996V9.21932L15.7874 8.32903C16.0198 8.07387 16.4151 8.05549 16.6703 8.28796C16.9254 8.52044 16.9438 8.91574 16.7114 9.17089L14.8132 11.2542ZM5.60217 8.7457C5.7215 8.61472 5.89082 8.54055 6.068 8.54164C6.24519 8.54273 6.41358 8.61897 6.5313 8.7514L8.38315 10.8347C8.61247 11.0927 8.58924 11.4878 8.33125 11.7171C8.07326 11.9464 7.67821 11.9232 7.44889 11.6652L6.68917 10.8105V15C6.68917 15.115 6.78244 15.2083 6.8975 15.2083H12.0827C12.4279 15.2083 12.7077 15.4881 12.7077 15.8333C12.7077 16.1785 12.4279 16.4583 12.0827 16.4583H6.8975C6.09208 16.4583 5.43917 15.8054 5.43917 15V10.7806L4.62802 11.6709C4.39554 11.926 4.00024 11.9444 3.74509 11.712C3.48993 11.4795 3.47155 11.0842 3.70402 10.829L5.60217 8.7457Z"
      fill="#77757D"
    />
  </g>
  <defs>
    <clipPath id="clip0_7823_6859">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>`;
